import { FiMaximize2, FiMinimize2 } from "react-icons/fi";

const ExpandableDiv = (props) => {
  const componentProps = {
    ...props,
    className: `h-5 relative overflow-visible ${props.className}`,
  };

  const handleExpand = (id) => {
    if (id === props.expanded) {
      props.setExpanded(null);
    } else {
      props.setExpanded(props.id);
    }
  };

  return (
    <div className={componentProps.className}>
      <div
        className={`w-full h-[32px] absolute top-[-10px] left-0 transition-all ease-in-out delay-200 pr-10 pl-4 pt-2 overflow-hidden ${
          props.expanded === props.id
            ? "h-auto shadow-md pb-[4px] rounded-md bg-[#eaf4fd] z-10"
            : ""
        }`}
      >
        {componentProps.children}
      </div>
      {componentProps.expandable && (
        <button
          className={`bg-[#5e73c0] lg:w-8 lg:h-8 w-7 h-7 rounded-md absolute -top-[6px] right-0 border-solid border-[#5a6fbd] border-2 text-center text-white pl-[2px] delay-300 ${
            props.expanded === props.id ? "z-10" : ""
          }`}
          onClick={() => handleExpand(props.id)}
        >
          {props.expanded === props.id ? (
            <FiMinimize2 className="lg:w-6 lg:h-6 w-5 h-5" />
          ) : (
            <FiMaximize2 className="lg:w-6 lg:h-6 w-5 h-5" />
          )}
        </button>
      )}
    </div>
  );
};

export default ExpandableDiv;
